import { Link, useLocation } from 'react-router';

import { TOP_BAR_SETTINGS_ICON_SRC } from '@/app/layout/AppTopBar/constants';
import { paths } from '@/app/routes/paths';
import { messages } from '@/shared/i18n';
import { cn } from '@/shared/lib/cn';

const settingsLabel = messages.workspace.hubs.organisationSettings.label;

/**
 * Org-admin workspace settings — top-bar icon beside notifications (same asset pattern as bell).
 */
export function WorkspaceSettingsNavLink({ to = paths.organisationSettings }: { to?: string }) {
  const { pathname } = useLocation();
  const active = pathname.startsWith(paths.organisationSettings);

  return (
    <Link
      to={to}
      aria-label={settingsLabel}
      title={settingsLabel}
      aria-current={active ? 'page' : undefined}
      className={cn(
        'flex size-[37px] shrink-0 items-center justify-center rounded-[24px] bg-white shadow-card transition-colors hover:bg-brand-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand/35 focus-visible:ring-offset-2',
        active && 'bg-brand-50 ring-1 ring-inset ring-brand/25',
      )}
    >
      <img src={TOP_BAR_SETTINGS_ICON_SRC} alt="" className="size-4 object-contain" />
    </Link>
  );
}
